import React, { FC } from 'react';

import { EvIcon, EvLink, EvTitle } from '@evinced-private/ui-common';

import EvincedIcon from 'src/common/components/icons/EvincedIcon.svg?raw';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';

import './AnnouncementBanner.scss';

export const AnnouncementBanner: FC = () => {
	return (
		<div className="mfa-banner-wrapper">
			<EvIcon icon={EvincedIcon} />
			<div className="mfa-banner-content">
				<EvTitle
					className="mfa-banner-title"
					titleText="Welcome to the new Evinced Platform — Mobile Flow Analyzer"
				/>
				<div className="mfa-banner-body">
					<div className="mfa-banner-text">
						Reports are available for the Mobile Flow Analyzer version 10.0 and newer. Latest
						version is available at{' '}
						<EvLink url={RoutesHelper.getMfaProductHubUrl()} linkText="Evinced Product Hub" />.
					</div>
					<div className="mfa-banner-text">
						To see reports from previous versions, go to the{' '}
						<EvLink url={RoutesHelper.getMfaV1DashboardPath()} linkText="previous platform" />.
					</div>
				</div>
			</div>
		</div>
	);
};
